import {UserContactType} from "../../../../types/domain.ts";
import {FormRule} from "antd";

type Func = (value: string) => string;
export const contactTransformers: Record<UserContactType, Func> = {
    telegram: (v) => {
        const input = v.trim();
        if (input.startsWith('https://t.me/') || input.startsWith('http://t.me/')) {
            return input.split('/').pop()!;
        }
        if (input.startsWith('t.me/')) {
            return input.split('/').pop()!;
        }
        if (input.startsWith('@')) {
            return input.slice(1);
        }
        return input;
    },
    discord: (v) => {
        const input = v.trim();
        if (input.startsWith('@')) {
            return input.slice(1);
        }
        return input;
    },
    wa: (v) => v,
    tel: (v) => v,
    email: (v) => v,
}

export const contactRules: Record<UserContactType, FormRule> = {
    telegram: {
        validator: (_, value) => {
            if (!value) {
                return Promise.reject(new Error('Обязательно'));
            }

            const trimmed = value.trim();

            let username = trimmed;
            if (trimmed.startsWith('https://t.me/') || trimmed.startsWith('http://t.me/')) {
                username = trimmed.split('/').pop();
            } else if (trimmed.startsWith('t.me/')) {
                username = trimmed.split('/').pop();
            } else if (trimmed.startsWith('@')) {
                username = trimmed.slice(1);
            }

            const isValid = /^[a-zA-Z0-9_]{5,32}$/.test(username);
            if (!isValid) {
                return Promise.reject(
                    new Error('Некорректный формат имени пользователя')
                );
            }

            return Promise.resolve();
        }
    },
    discord: {
        validator: (_, value) => {
            if (!value) {
                return Promise.reject(new Error('Обязательно'));
            }

            let trimmed = value.trim();
            if (trimmed.startsWith('@')) {
                trimmed = trimmed.slice(1);
            }

            const isValid = /^[a-z0-9_.]{2,32}$/.test(trimmed);
            if (!isValid) {
                return Promise.reject(
                    new Error('Некорректный формат имени пользователя')
                );
            }

            return Promise.resolve();
        }
    },
    wa: {
        required: true
    },
    tel: {
        required: true
    },
    email: {
        required: true,
        type: 'email',
    }
}